class AbstractController
  clj = {}
  ModalService = null

  constructor: (injector) ->
    injector.invoke(['promiseTracker', '$uibModal', 'Alert', 'Confirm'
      (promiseTracker, modalService, AlertFactory, ConfirmFactory) =>
        ModalService = modalService
        @promiseTracker = promiseTracker
        @Alert = AlertFactory
        @Confirm = ConfirmFactory
    ])
    @debug = true

  openPopup: (url, controller, size = null, backdrop = true, options = {}) ->
    (resolve, callback)=>
      modalInstance = ModalService.open(angular.extend({
        size: size
        backdrop: backdrop
        keyboard: backdrop != 'static'
        templateUrl: url + if @debug then '?no-cache=' + (new Date()).getTime() else ''
        controller: controller
        resolve: resolve
      }, options))

      modalInstance.result.then((retorno) ->
        callback(retorno) if callback
      )

  clearLazyLoad: (identifier) ->
    clj[identifier] = undefined

  resetLazyLoad: ->
    clj = {}

  lazyLoad: (identifier, loadFn)->
    promiseTracker = @promiseTracker()
    ->
      return clj[identifier] if clj[identifier]? or promiseTracker.active()
      promiseTracker.addPromise loadFn((data)->
        clj[identifier] = data)

  getHash: (object)->
    cbk.hashCode object if object

  cancel: ->
    @modalInstance.dismiss 'cancel'

  cbkDownload: (path) ->
    cbk.download(path)

window.AbstractController = AbstractController
